import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "./popupThumbnail.scss";
import { Document, Page } from "react-pdf";
import ReactPlayer from "react-player";
import PdfViewer from "./PdfViewer";

const PoppupThumbnail = ({
  CloseThumbnailPopup,
  attachmenturl,
  attachmentType,
}) => {
  
  return (
    <div className="popup_thumbnail">
      <div className="content_viewer">
        <div className="popup_close_icon">
          <img src={Image_Url.CROSSICONS} onClick={CloseThumbnailPopup} />
        </div>

        {attachmentType.toLowerCase()  === "pdf" ? (
          <PdfViewer pdfUrls={attachmenturl} />
        ) : attachmentType.toLowerCase()  === "video" ? (
          <ReactPlayer
            url={attachmenturl}
            controls={true}
            width="100%"
            height="90%"
          />
        ) : attachmentType.toLowerCase()  === "scorm" ? (
          <ReactPlayer
            url={attachmenturl}
            controls={true}
            width="100%"
            height="90%"
          />
        ) : (
          <p>Unsupported file type</p>
        )}
      </div>
    </div>
  );
};

export default PoppupThumbnail;
